var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnthropicIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.2,
    height: 65,
    viewBox: "0 0 92.2 65",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Anthropic_icon",
    d: "M66.5,0H52.4L78.1,65H92.2ZM25.7,0,0,65H14.4l5.3-13.6H46.6L51.8,65H66.2L40.5,0ZM24.3,39.3l8.8-22.8,8.8,22.8Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnthropicIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Anthropic_icon.fd6bcac06df84695e758a24e18aec977.svg";